import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class VaultAuthGuardService  {
  constructor(private router: Router, private authService: AuthService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url: string = state.url;
    if (await this.authService.isAuthenticated()) {
      const user = await this.authService.user;
      if (user?.user_type != UserTypeEnum.Professional) {
        return true;
      } else {
        if (url.includes('relationship')) {
          this.router.navigate(['/office-relationship']);
        } else {
          this.router.navigate(['/home']);
        }

        return false;
      }
    }

    await this.authService.isAuthenticated().then(async (user) => {
      // if there is no user, navigate to '/' and set the exact redirect url
      if (!user) {
        this.router.navigate(['/']);
        this.authService.redirectUrl = url;
      }
      else {
        const user = await this.authService.user;
        if (user?.user_type != UserTypeEnum.Professional) {
          return true;
        } else {
          if (url.includes('relationship')) {
            this.router.navigate(['/office-relationship']);
          } else {
            this.router.navigate(['/home']);
          }

          return false;
        }
      }
    });

    return false;
  }
}
